import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    changepassshow: false,
  },
  mutations: {
    setUser(state, n) {
      state.user = n;
    },
    setChangepassshow(state, n) {
      state.changepassshow = n;
    },
  },
  actions: {},
  modules: {},
});
